import { useStyletron } from 'baseui';

const useStyles = () => {
	const [css] = useStyletron();
	const externalLoginClasses = {
		formControlContainer: {
			outline: `black solid`,
			backgroundColor: 'white',
			width: '300px'
		},
		formControlLabel: {
			fontWeight: 'bold'
		},
		otpButton: css({ width: '100%', display: 'flex', flexDirection: 'row-reverse' }),
		signInButton: css({ width: '100%', display: 'flex', justifyContent: 'center' })
	};

	return { ...externalLoginClasses };
};

export default useStyles;
